module.exports = __webpack_public_path__ + "img/averageMoneyCommission.c57876fd.svg";